import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { InputNumberModule } from "primeng/inputnumber";
import { ButtonModule } from "primeng/button";
import { CatalogTemplateComponent } from "./catalog-template.component";
import { CatalogPageComponent } from "./catalog-page.component";
import { CatalogCellComponent } from "./catalog-cell.component";
import { InputDimensionComponent } from "./input-dimension.component";
import { SidebarModule } from "primeng/sidebar";
import { CheckboxModule } from "primeng/checkbox";
import { ThemeCreatorService } from "./theme-creator.service";
import { AccordionModule } from "primeng/accordion";
import { DropdownModule } from "primeng/dropdown";
// import { MonacoEditorModule } from "ngx-monaco-editor-v2";
import { ContainerComponent } from "./components/container.component";
import { ElementComponent } from "./components/element.component";
import { ListingComponent } from "./components/listing.component";
import { TextComponent } from "./components/text.component";
import { RootComponent } from "./components/root.component";

@NgModule({
  declarations: [
    CatalogTemplateComponent,
    CatalogPageComponent,
    CatalogCellComponent,
    InputDimensionComponent,
    ContainerComponent,
    ElementComponent,
    ListingComponent,
    TextComponent,
    RootComponent,
  ],
  imports: [
    AccordionModule,
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    SidebarModule,
    CheckboxModule,
    DropdownModule,
    // MonacoEditorModule.forRoot(),
  ],
  providers: [ThemeCreatorService],
  exports: [CatalogTemplateComponent],
})
export class ThemeCreatorModule {}
